export enum BillingGroup {
   Billable = 'billable',
   NonBillable = 'non-billable',
}
